module.exports = __webpack_public_path__ + "img/sub-page-hero-bg.4c97bec4.svg";